export const USE_NOTIFICATION_DEMO_DATA = true;

const customerRecipients = [
  {
    id: "cust-1001",
    name: "Aarav Sharma",
    email: "aarav.sharma@demo.seeb.in",
    mobile: "+91 98765 43210",
  },
  {
    id: "cust-1002",
    name: "Priya Nair",
    email: "priya.nair@demo.seeb.in",
    mobile: "+91 98765 43211",
  },
  {
    id: "cust-1003",
    name: "Rohan Mehta",
    email: "rohan.mehta@demo.seeb.in",
    mobile: "+91 98765 43212",
  },
  {
    id: "cust-1004",
    name: "Sneha Iyer",
    email: "sneha.iyer@demo.seeb.in",
    mobile: "+91 98765 43213",
  },
  {
    id: "cust-1005",
    name: "Vikram Singh",
    email: "vikram.singh@demo.seeb.in",
    mobile: "+91 98765 43214",
  },
];

const partnerRecipients = [
  {
    id: "partner-2001",
    name: "Urban Clean Experts",
    email: "ops@urbanclean.demo",
    mobile: "+91 91234 56001",
  },
  {
    id: "partner-2002",
    name: "Sparkle Home Services",
    email: "team@sparklehome.demo",
    mobile: "+91 91234 56002",
  },
  {
    id: "partner-2003",
    name: "BlueNest Facility Care",
    email: "hello@bluenest.demo",
    mobile: "+91 91234 56003",
  },
  {
    id: "partner-2004",
    name: "Rapid Fix Partners",
    email: "support@rapidfix.demo",
    mobile: "+91 91234 56004",
  },
];

const selectRecipients = (items, ids) =>
  items
    .filter((item) => ids.includes(item.id))
    .map((item) => ({
      id: item.id,
      name: item.name,
      meta: item.email || item.mobile || "-",
    }));

export const getMockRecipients = (moduleType) => {
  if (moduleType === "partner") {
    return partnerRecipients.map((item) => ({ ...item }));
  }

  return customerRecipients.map((item) => ({ ...item }));
};

export const getMockNotificationDraft = (channel) => {
  if (channel === "sms") {
    return {
      target: "Booking Reminder",
      subject: "Slot Reminder",
      message: "Reminder: your Seeb service is scheduled for tomorrow at 11:00 AM. Reply HELP if you need support.",
    };
  }

  return {
    target: "Festival Campaign",
    subject: "Your home refresh offer is ready",
    message:
      "Hi there,\n\nWe have added a limited-time cleaning and sanitization offer for this week. Book your preferred slot and enjoy a smooth, hassle-free home service experience.\n\nTeam Seeb",
  };
};

export const getMockNotificationHistory = () => [
  {
    id: "demo-email-001",
    sentAt: "2026-03-22T10:15:00+05:30",
    channel: "email",
    module: "customer",
    target: "Festival Campaign",
    subject: "Premium cleaning offer for returning customers",
    message:
      "Hello,\n\nWe are offering a 15% discount on premium cleaning packages this week. Book now to lock your preferred time slot.\n\nRegards,\nTeam Seeb",
    totalRecipients: 3,
    recipients: selectRecipients(customerRecipients, ["cust-1001", "cust-1002", "cust-1004"]),
    attachments: [
      {
        name: "festival-offer.pdf",
        size: 245760,
        type: "application/pdf",
      },
    ],
    endpoint: "notification/send-email",
    status: "sent",
    isDemo: true,
  },
  {
    id: "demo-sms-001",
    sentAt: "2026-03-21T17:40:00+05:30",
    channel: "sms",
    module: "partner",
    target: "Shift Reminder",
    subject: "Tomorrow's assignment update",
    message:
      "Reminder: tomorrow's partner assignment starts at 9:30 AM. Please check the dashboard 30 minutes before the shift.",
    totalRecipients: 2,
    recipients: selectRecipients(partnerRecipients, ["partner-2001", "partner-2003"]),
    attachments: [],
    endpoint: "notification/send-sms",
    status: "sent",
    isDemo: true,
  },
];
